import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';
import {FormViewRowV2} from '../FormViewRow/FormViewRowV2';
import {
  describePersonnelSelection,
  type PersonnelSelectionValue,
} from './personnelSummary';

export interface FormViewPersonnelSummaryV2Props {
  field: IFormFieldV2;
  value: PersonnelSelectionValue;
}

export const FormViewPersonnelSummaryV2: React.FC<
  FormViewPersonnelSummaryV2Props
> = ({field, value}) => {
  return (
    <FormViewRowV2 field={field} value={describePersonnelSelection(value)} />
  );
};
